import { createFileRoute, Outlet } from '@tanstack/react-router';

// The judgment list and a trace are siblings: opening a trace does not
// render the list as its layout.
export const Route = createFileRoute('/_app/admin/agent/judge')({
    component: Outlet,
});
